import produce from 'immer';
import { setPassengers, setPassengerSelect } from './actions';
const initialState = {};
function passengersReducer(state = initialState, { type, payload }) {
    return produce(state, draft => {
        switch (type) {
            case setPassengers.toString():
                Object.assign(draft, payload);
                break;
            case setPassengerSelect.toString():
                const actionPayload = payload;
                const ids = Array.isArray(actionPayload.id) ? actionPayload.id : [actionPayload.id];
                ids.forEach(id => (draft[id] = actionPayload.selected));
                break;
        }
    });
}
export default passengersReducer;
